<!--
 * Todo: Add translation strings.
 * Todo: Translate.
-->
<template>
	<header id="header">
		<main-navigation></main-navigation>
		<sub-navigation></sub-navigation>
	</header>
	<main id="main">
		<router-view/>
		<div class="notification__wrapper">
			<template v-for="notification in $store.state.notifications" :key="notification.title">
				<div @click="hideNotification(notification.id)" :class="['notification__entry', 'notification--'+notification.type]" v-if="notification.active">
					<div v-if="notification.title" class="title">{{notification.title}}</div>
					<div v-if="notification.text" class="text" v-html="notification.text"></div>
					<div class="close">&nbsp;</div>
				</div>
			</template>
		</div>
	</main>
</template>

<script>
import MainNavigation from './components/MainNavigation.vue';
import SubNavigation from './components/SubNavigation.vue';
import axios from 'axios'

	export default {
		components: {
			MainNavigation,
			SubNavigation,
		},
		created() {
			document.title = 'Loxone Library';
			//LANG CHANGE START
			var library_lang = getCookie('library_lang');
			var cookie_val = 'en_gb';

			if(library_lang != ""){
				cookie_val = library_lang;
			}else{
				cookie_val = getCookie('geoip_website');
			}

			if(cookie_val == 'dede' || cookie_val == 'de'){
				this.$i18n.locale = 'en_gb';
			}else{
				this.$i18n.locale = 'en_gb';
			}

			function getCookie(cname) {
				var name = cname + "=";
				var decodedCookie = decodeURIComponent(document.cookie);
				var ca = decodedCookie.split(';');
				for(var i = 0; i <ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
					c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
					}
				}
				return "";
			}
		},
		mounted: function() {
			window.setInterval(() => {
				this.$store.dispatch('checkNotifications');
			}, 3000)
		},
		methods: {
			hideNotification(id) {
				this.$store.dispatch('hideNotification', id);
			}
		},
		watch: {
            '$route': function () {
				window.scrollTo(0, 0);

				var checkData = new FormData;
				checkData.append('route', JSON.stringify(this.$route));
				checkData.append('data', JSON.stringify(this.$store.state.userData));
				axios({
					method: 'post',
					crossDomain: true,
					withCredentials: true,
					data: checkData,
					url: 'https://api.library.loxone.com/checkUserSession',
				})
				.then(resp => {
					if(!resp.data.allowed) {
						this.$router.replace({
							name: "Error404",
							replace: true,
						});
					}
					if (resp.data && resp.data.valid) {
						this.$store.state.loggedIn = resp.data.valid;

						if (resp.data.userData) {
							this.$store.state.userData = resp.data.userData;
						}
					}
				})
            }
        }
	}
</script>

<style lang="scss">
	@import "./scss/_style.scss";
	
	a{
		cursor: pointer;
	}

	.notification__wrapper{
		position: fixed;
		right: 0;
		max-width: 500px;
		bottom: 0;
	}

	.notification__entry{
		padding: 7px 50px 10px 20px;
		margin: 0 20px 20px 0;
		border: 1px solid #bee5eb;
		color: #0c5460;
		background-color: #d1ecf1;
		border-radius: 5px;
		position: relative;

		.title{
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 5px;
		}

		.text{
			font-size: 16px;
		}
		.close{
			width: 20px;
			height: 20px;
			cursor: pointer;
			position: absolute;
			top: 10px;
			right: 10px;
			font-size: 0;
			line-height: 0;

			&:before,
			&:after{
				display: inline-block;
				height: 20px;
				width: 2px;
				background: black;
				content: "";
				transform: rotate(45deg);
				margin-left: 10px;
			}
			&:after{
				transform: rotate(-45deg);
				margin-left: -2px;
			}
		}

		&.notification--success{
			color: #155724;
			background-color: #d4edda;
			border-color: #c3e6cb;
		}

		&.notification--error{
			color: #721c24;
			background-color: #f8d7da;
			border-color: #f5c6cb;
		}

		&.notification--warning{
			color: #856404;
			background-color: #fff3cd;
			border-color: #ffeeba;
		}

		&.notification--primary{
			color: #004085;
			background-color: #cce5ff;
			border-color: #b8daff;
		}
	}
</style>